module.exports = {
  __init__: [ 'bpmnRenderer' ],
  bpmnRenderer: [ 'type', require(5) ],
  pathMap: [ 'type', require(6) ]
};
